import "./checkbox.scss";

import React, { useState, useEffect } from "react";

const Checkbox = ({ label, value, onChange, id, checked }) => {
  const [active, setActive] = useState(checked);
  const handleChange = () => {
    onChange();
    setActive(!active);
  };
  useEffect(() => {
    setActive(checked);
  }, [checked]);
  return (
    <div className="checkbox-wrapper">
      <input
        type="checkbox"
        id={id ? id.toLowerCase() : label.toLowerCase()}
        name={label?.toLowerCase()}
        className="checkbox-wrapper__checkbox"
        onChange={handleChange}
        value={value}
        checked={active}
      />
      <label htmlFor={label?.toLowerCase()} className="checkbox-wrapper__label">
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
